import { service } from '@ember/service';
import Component from '@glimmer/component';

export default class UiFormSectionsVariantComponent extends Component {
  @service recordVariants;

  get isVariant() {
    return this.recordVariants.isVariant(this.args.form.model);
  }

  get isChannelVariant() {
    return this.recordVariants.isChannelVariant(this.args.form.model);
  }

  <template>
    {{#if this.isVariant}}
      <@form.fieldset @titleKey='variant' as |fieldset|>
        {{#if this.isChannelVariant}}
          <fieldset.field
            @property='variantChannel'
            @type='belongs-to'
            @on={{@variantChannelActions}}
          />
        {{/if}}

        <fieldset.field
          @property='cmsLanguageId'
          @type='select-value'
          @options={{@availableLanguages}}
        />
      </@form.fieldset>
    {{/if}}
  </template>
}
